class CharacterLimit {
    constructor( sourceElement ) {
        this.el = sourceElement;
        this.limit = this.el.dataset.limit || 1000;

        this.suffix = this.el.dataset.characterLimitSuffix;

        this.counter = document.createElement( 'small' );
        this.counter.className = 'twc__character--limit-counter';

        this.setCounter();

        this.el.parentNode.style[ 'position' ] = 'relative';
        this.el.parentNode.style[ 'padding-bottom' ] = '20px';

        this.el.parentNode.appendChild( this.counter );

        this.el.addEventListener( 'input', this.change.bind( this ) );

        if ( this.el.value.length >= this.limit ) {
            this.el.classList.add( 'twc__character--limit-reached' );
            this.counter.add( 'twc__character--limit-reached' );
        }

        this.el.classList.add( 'twc__character--limit-initialised' );
    }

    update() {
        if ( this.el.value.length >= this.limit ) {
            this.el.classList.add( 'twc__character--limit-reached' );
            this.counter.classList.add( 'twc__character--limit-reached' );
            this.el.value = this.el.value.substring( 0, this.limit );
        } else {
            this.el.classList.remove( 'twc__character--limit-reached' );
            this.counter.classList.remove( 'twc__character--limit-reached' );
        }
        this.setCounter();
    }

    change() {
        this.update( false );
    }

    setCounter() {
        this.counter.innerText = this.el.value.length + '/' + this.limit + ' ' + this.suffix;
    }

    static init( parent ) {
        const container = parent || document;
        const elements = container.getElementsByClassName( 'twc__character--limit' );

        for ( let i = 0; i < elements.length; i++ ) {
            if ( elements[ i ].classList.contains( 'twc__character--limit-initialised' ) ) {
                continue;
            }
            new CharacterLimit( elements[ i ] );
        }
    }
}

export default function initCharacterLimit() {
    CharacterLimit.init( document );

    document.addEventListener( 'twc:newcontentloaded', function( event ) {
        const detail = event.detail || {};
        CharacterLimit.init( detail.container || document );
    } );
}
